export function updateObjectInArray(array: any[], action) {
  return array.map((item, index) => {
    if (index !== action.index) {
      // This isn't the item we care about - keep it as-is
      return item;
    }

    // Otherwise, this is the one we want - return an updated value
    return {
      ...item,
      ...action.item,
    };
  });
}

export function removeItemFromArray(array: any[], item): any[] {
  const index = array.findIndex((i) => i === item);

  return [...array.slice(0, index), ...array.slice(index + 1)];
}
